const state = {
  userInfo: {},
  phoneInfo: {},
}

const getters = {
  getUserInfo: state => state.userInfo,
  getPhoneInfo: state => state.phoneInfo,
}

const mutations = {
  setUserInfo(state, object) {
    state.userInfo = object
  },
  setPhoneInfo(state, object) {
    state.phoneInfo = object
  },
  cleanStore(state, object) {
    state.userInfo = {}
  },
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js